import React, { useState} from "react";
import {IUsers} from "../../types/IUsers.ts";
import {UserContext} from "./user-context.tsx";
import {IGameStat, LocalStorageKey} from "../../types/IGameStat.ts";
import {IAIChallengeWord} from "../../common/utils/http/IResponse.ts";

export const UserStorageProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
    // 使用 useState 来管理用户信息的状态
    const [user, setUser] = useState<IUsers>();
    // 当前的nextTime
    const [nextTime, setNextTime] = useState<number>(0)
    // 游戏信息 暂时用于profile里的stat
    const [gameStats, setGameStats] = useState<IGameStat>();
    const [challengeWords, setChallengeWords] = useState<IAIChallengeWord[]>([]);
    const [aiLevel, setAiLevel] = useState<number>(1);

    // 是否已经官方登录过了，主要是如果已经登录过了就不再检测，用于退出功能
    const [hasLoginByApp, setHasLoginByApp] = useState(false);

    // 清除本地用户数据
    const clearUser = () => {
        localStorage.removeItem(LocalStorageKey.USER);  // 移除本地存储中的用户信息
        localStorage.removeItem(LocalStorageKey.TOKEN);  // 移除本地存储中的token
        setUser(undefined);
        localStorage.removeItem(LocalStorageKey.GAME_STATS) // 移除本地存储中的游戏数据
        setGameStats(undefined)
        setHasLoginByApp(true)
    }

    return (
        <UserContext.Provider
            value={{
                nextTime,
                setNextTime,
                user,
                setUser,
                clearUser,
                gameStats,
                setGameStats,
                challengeWords,
                setChallengeWords,
                aiLevel,
                setAiLevel,
                hasLoginByApp,
                setHasLoginByApp
            }}>
            {children}
        </UserContext.Provider>
    );
};

